import React from "react";
import Cta from "../cta/cta";

const B2BDataCta = () => {
  return (
    <Cta
      heading="Ready to unlock unlimited opportunities?"
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default B2BDataCta;
